export const defaultDailyChartsState = {
  charts: {
    primary: { values: [], range: { min: 0, max: 0 }, yAxis: '' },
    secondary: { values: [], range: { min: 0, max: 0 }, yAxis: '' },
  },
}
